module.exports = __webpack_public_path__ + "static/media/image-choice-light-pink.0663b653.svg";